<div class="report-modal">
    <button type="button" class="report-modal__close-btn" aria-label="Fechar" (click)="close()">
        <app-svg-icon src="assets/icons/close-icon.svg" width="17px" color="arrowGray"></app-svg-icon>
    </button>

    <div class="report-modal__body">
        <div class="execution-meta" *ngIf="executionInfo && state !== 'loading'">
            <span class="execution-meta__item" *ngIf="executionInfo.TriggeredByUsername">
                <strong>Solicitado por:</strong> {{ executionInfo.TriggeredByUsername }}
            </span>
            <span class="execution-meta__item" *ngIf="executionInfo.StartedAt">
                <strong>Início:</strong> {{ executionInfo.StartedAt | systemDate:'dd/MM/yyyy HH:mm:ss' }}
            </span>
            <span class="execution-meta__item" *ngIf="executionInfo.FinishedAt">
                <strong>Fim:</strong> {{ executionInfo.FinishedAt | systemDate:'dd/MM/yyyy HH:mm:ss' }}
            </span>
        </div>

        <ng-container [ngSwitch]="state">

        <ng-container *ngSwitchCase="'result'">
            <div class="summary d-flex flex-wrap">
                <div class="summary-item">
                    <span class="summary-label">Parceiros processados</span>
                    <span class="summary-value">{{ result?.ProcessedMastersCount }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Contratos processados</span>
                    <span class="summary-value">{{ processedContractsCount }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Lotes criados</span>
                    <span class="summary-value">{{ result?.CreatedNewCount || 0 }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Lotes reaproveitados</span>
                    <span class="summary-value">{{ result?.AddedToExistingCount || 0 }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Falhas</span>
                    <span class="summary-value">{{ failureCount }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Contratos não loteados</span>
                    <span class="summary-value">{{ result?.ExcludedContracts?.length || 0 }}</span>
                </div>
            </div>

            <div class="empty mt-16" *ngIf="rows.length === 0">
                <span class="empty-text">Não há dados para exibir</span>
            </div>

            <div class="report-grid mt-16" *ngIf="rows.length !== 0">
                <div class="report-grid__row report-grid__row--head">
                    <div class="report-grid__cell">Categoria</div>
                    <div class="report-grid__cell">Lote</div>
                    <div class="report-grid__cell">Contrato</div>
                    <div class="report-grid__cell">Parceiro</div>
                    <div class="report-grid__cell report-grid__cell--reason">Motivo</div>
                </div>

                <div class="report-grid__row" *ngFor="let row of rows" [class.report-grid__row--note]="row.IsNote">
                    <div class="report-grid__cell">{{ row.Categoria }}</div>
                    <div class="report-grid__cell report-grid__cell--strong">{{ row.Lote }}</div>

                    <div class="report-grid__cell report-grid__cell--stacked">
                        <span class="stacked-number-row">
                            <span class="stacked-number">{{ row.Contrato }}</span>
                            <span class="version-tag" *ngIf="row.Versao !== '-'">v{{ row.Versao }}</span>
                        </span>
                        <span class="stacked-subtext" *ngIf="row.QueryNumber !== '-'">{{ row.QueryNumber }}</span>
                    </div>

                    <div class="report-grid__cell report-grid__cell--stacked">
                        <span class="stacked-number">{{ row.Parceiro }}</span>
                        <span class="stacked-subtext" *ngIf="row.Cnpj !== '-'">{{ row.Cnpj }}</span>
                    </div>

                    <div class="report-grid__cell report-grid__cell--reason">{{ row.Motivo }}</div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'running'">
            <div class="progress-state">
                <p class="progress-state__text">
                    Processando a geração de lotes de repasse automático
                </p>
                <p class="progress-state__phase">
                    {{ currentPartnerText || (totalCount ? (processedCount + ' de ' + totalCount + ' parceiros processados') : 'Buscando contratos elegíveis para o processamento...') }}
                </p>
                <span class="progress-state__percent" *ngIf="totalCount">
                    {{ hasContractProgress ? '~' + displayPercent : progressPercent }}%
                </span>
                <div class="progress-bar" [class.progress-bar--indeterminate]="!totalCount" role="progressbar"
                    [attr.aria-valuenow]="totalCount ? (hasContractProgress ? displayPercent : progressPercent) : null"
                    aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar__fill"
                        [style.width.%]="totalCount ? (hasContractProgress ? displayPercent : progressPercent) : null"></div>
                </div>
                <p class="progress-state__detail" *ngIf="contractsText || elapsedText">
                    <span *ngIf="contractsText">{{ contractsText }}</span>
                    <span *ngIf="contractsText && elapsedText"> · </span>
                    <span *ngIf="elapsedText">Tempo decorrido: {{ elapsedText }}</span>
                </p>
                <p class="progress-state__note" *ngIf="hasContractProgress">
                    Percentual estimado - atualiza com o valor real a cada parceiro concluído.
                </p>
                <p class="progress-state__hint">
                    Isso pode levar alguns minutos. Pode fechar esta janela - o processamento continua normalmente e você pode acompanhar depois.
                </p>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'error'">
            <div class="error-state">
                <span class="error-state__text">{{ errorMessage }}</span>
            </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <div class="summary summary--loading d-flex flex-wrap">
                <div class="summary-item" *ngFor="let item of [1,2,3,4,5]">
                    <app-skeleton variant="text" [lines]="2"></app-skeleton>
                </div>
            </div>

            <div class="mt-16">
                <app-skeleton variant="table-row" [rows]="8" [columns]="5"></app-skeleton>
            </div>
        </ng-container>

        </ng-container>
    </div>

    <div class="report-modal__footer">
        <button class="export ui-btn ui-btn--secondary" (click)="exportCsv()" [disabled]="rows.length === 0">
            Exportar CSV
        </button>
        <button class="close ui-btn ui-btn--primary" (click)="close()">
            Fechar
        </button>
    </div>
</div>
